exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-activity[data-v-5114b102]{background-color:#f8f9fa}.user-activity .table td[data-v-5114b102]{border-top-color:#fff}.user-activity .table tr:first-child td[data-v-5114b102]{border-top:none}", ""]);

// exports
